import tw from 'tailwind-styled-components'
import {cn} from '@containers/html-utils'
import {TwSwitcherType} from './types'

export const TwSwitchWrapper = tw.div<{$disabled?: boolean}>`
  group/switch
  flex
  items-center
  gap-8
  ${p => cn(p.$disabled ? 'pointer-events-none' : 'cursor-pointer')}
`

export const TwText = tw.div<{$disabled?: boolean}>`
  text-sm-regular
  text-icon-secondary
  ${p => {
    const cx: string[] = []
    if (p.$disabled) {
      cx.push('text-icon-disabled')
    } else {
      cx.push('text-icon-secondary')
    }
    return cx.join(' ')
  }}
`

export const TwSwitch = tw.div<TwSwitcherType>`
  relative
  rounded-full
  w-28
  h-16

  ${p => {
    const cx: string[] = []
    cx.push(p.$active ? 'bg-action-default' : 'bg-icon-disabled')
    if (p.$disabled) {
      cx.push('opacity-40')
    } else {
      cx.push(
        p.$active
          ? 'group-hover/switch:bg-action-hover'
          : 'group-hover/switch:bg-icon-placeholder'
      )
    }
    return cx.join(' ')
  }}

`

export const TwCircle = tw.label<TwSwitcherType>`
  absolute
  my-2
  w-12
  h-12
  rounded-full
  bg-icon-invert

  transition-transform
  transform
  duration-100
  ease-in-out

  ${p =>
    p.$active ? `translate-x-full mr-2 right-12` : `translate-x-0 ml-2 left-0`}
`
